import { BaseError } from '@canvas/error';

import { CanvasRendererError } from './renderer-error';
import { type ErrorType, CanvasErrorType, type IdentifiedError } from './types';

export function identifyErrorType(error: unknown): ErrorType {
  if (!(error instanceof Error)) {
    return {
      type: CanvasErrorType.UNKNOWN_ERROR,
      isRecoverable: false,
    };
  }

  if (
    error.name === CanvasErrorType.ANONYMOUS_NOT_SUPPORTED_ERROR ||
    error.name === CanvasErrorType.TENANT_ID_MISSING_ERROR ||
    error.name === CanvasErrorType.IDENTITY_USER_FAILED_ERROR ||
    error.name === CanvasErrorType.DYNAMIC_IMPORT_ERROR ||
    error.name === CanvasErrorType.SHADER_COMPILATION_ERROR ||
    error.name === CanvasErrorType.NO_SESSION_DATA_ERROR
  ) {
    return {
      type: error.name,
      isRecoverable: false,
    };
  }

  if (
    error instanceof ErrorEvent &&
    error.error.name === CanvasErrorType.DYNAMIC_IMPORT_ERROR
  ) {
    return {
      type: CanvasErrorType.DYNAMIC_IMPORT_ERROR,
      isRecoverable: false,
    };
  }

  if (
    error instanceof CanvasRendererError &&
    (error.originalError?.name === CanvasErrorType.UNRECOVERABLE_WEB_GL_ERROR ||
      error.originalError?.name === CanvasErrorType.RECOVERABLE_WEB_GL_ERROR)
  ) {
    return {
      type: error.originalError.name,
      isRecoverable: false,
    };
  }

  return {
    type: CanvasErrorType.UNKNOWN_ERROR,
    isRecoverable: false,
  };
}

export function identifyError(error: Error): IdentifiedError {
  const { type, isRecoverable } = identifyErrorType(error);

  return {
    error,
    type,
    isRecoverable,
    ignoreUfoReporting: error instanceof BaseError ? error?.ignoreUfoReporting : false,
  };
}
